let baseUrl = "https://geco-api.azurewebsites.net/";	// the base URL to connect to for api calls
let enableLogin = true;									// permit users to login or not
let enableCompanyEdit = true;							// feature to edit company information
let enableAdminCompanyList = true;						// feature to allow geco admin to view all companies
let enableAdminUserInvite = true;						// feature to invite a new user

if (window.origin === "http://localhost:3000") {
	baseUrl = "https://localhost:7198/";
	enableLogin = true;
	enableCompanyEdit = true;
	enableAdminCompanyList = true;
	enableAdminUserInvite = true;
}

if (window.origin.includes("purple-beach")) {
	// this is the staging environment static app
	// use the staging api for it
	baseUrl = "https://geco-api-staging.azurewebsites.net/";
}

if (window.origin.includes("proud-sand")) {
	// VibeOps staging environment
	baseUrl = "https://geco-staging-api.azurewebsites.net/";
}

if (window.origin.includes("https://blue-smoke-054b86a1e-77.westus2.3.azurestaticapps.net")) {
	enableLogin = true;
}


export const Config = {
	baseUrl,
	enableMultiFields: false,
	enableMultiFarms: false,
	enableUsers: false,
	enableLogin,
	enableCompanyEdit,
	enableAdminCompanyList,
	enableAdminUserInvite,
	recaptchaSiteKey: "6LcxEHgsAAAAAPb3yHJ1Q3QRG87Zli7iWKRInM8k",
	cmsGoogleClientIdVibeOps: "435679930651-qe2mf6kf9hsenbl47t7k1o4563v4k81q.apps.googleusercontent.com",
	cmsGoogleClientId: "998056608030-qne4ahrm08m7j31m9gre9uh0h2pqghh2.apps.googleusercontent.com",
};
